import type { VoidFunctionComponent } from 'react';

import ProjectGroupTokenSettings from '../../../components/ProjectGroupPortalSettings';
import type { PortalTokenSettingsProps } from '../../../components/ProjectGroupPortalSettings';

import styles from '../ReleaseGroupsRevamp.module.less';

/**
 * Render the portal settings section with the section style applied.
 */
const PortalSettings: VoidFunctionComponent<PortalTokenSettingsProps> = (props) => {
  return (
    <div className={styles.section}>
      <ProjectGroupTokenSettings {...props} />
    </div>
  );
};

export default PortalSettings;
